<div class="container-fluid bottom-stripe year">
  <div class="row text-center">
    <div class="col">
      &copy; 2017-2023
      <a [routerLink]="['/contact']">Better Coder, s.r.o.</a>
    </div>
  </div>
</div>
